import { Component } from '@angular/core';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';



@Component({
    selector: 'app-capture-history-item-type-client-chore-updated',
    templateUrl: './capture-history-item-type-client-chore-updated.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeClientChoreUpdatedComponent extends CaptureHistoryItemTypeBaseComponent {
  get title() {
    return "Updated By Chore";
  }

  get choreId() {
    return this.captureHistoryItem.data?.choreId || 'N/A';
  }

  get choreDisplayName() {
    return this.captureHistoryItem.data?.choreDisplayName;
  }

  get notes() {
    return this.captureHistoryItem.data?.notes;
  }

  get error() {
    return this.captureHistoryItem.data?.error;
  }
}
